import 'innersvg-polyfill';
import { css, LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';

const _fetchMap = /* @__PURE__ */new Map();
const getByUrl = uri => {
  const responseParser = response => response.text();
  if (!_fetchMap.has(uri)) {
    _fetchMap.set(uri, fetch(uri).then(responseParser).catch(() => {}));
  }
  return _fetchMap.get(uri);
};

var styles = css`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    50% {
      transform: rotate(359deg);
    }

    51% {
      transform: rotate(0deg);
    }

    75% {
      transform: rotate(134deg);
    }

    100% {
      transform: rotate(359deg);
    }
  }

  :host {
    fill: currentcolor;
    color: inherit;
    display: inline-flex;
    pointer-events: none;
    vertical-align: text-top;
  }

  :host(:not(:root)) {
    overflow: hidden;
  }

  :host([icon="action:loader"]) svg path:last-of-type {
    animation: spin 0.8s cubic-bezier(0.17, 0.67, 1, 1) infinite;
    transform-origin: center;
  }

  @media (forced-colors: active) {
    .aileron-icon,
    :host {
      forced-color-adjust: auto;
    }
  }

  #container {
    height: 100%;
  }

  img,
  svg,
  ::slotted(*) {
    vertical-align: top;
  }

  svg path {
    fill: var(--icon-fill, var(--color-light-mode-icon-icon-interactive));
  }
`;

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
class Icon extends LitElement {
  constructor() {
    super(...arguments);
    this.size = 16;
    this.filled = false;
    this.outlined = false;
  }
  async fetchIcon(icon) {
    const category = icon.split(":")[0];
    const name = icon.split(":")[1];
    const data = await getByUrl(`https://cdn.aa.com/aileron/icons/${category}${this.outlined ? "/outlined/" : this.filled ? "/filled/" : "/"}${name}.svg`);
    const dom = new DOMParser().parseFromString(data, "text/html");
    const svg = dom.body.querySelector("svg");
    svg == null ? void 0 : svg.setAttribute("width", this.size.toString());
    svg == null ? void 0 : svg.setAttribute("height", this.size.toString());
    svg == null ? void 0 : svg.setAttribute("fill", "currentColor");
    svg == null ? void 0 : svg.setAttribute("aria-hidden", "true");
    return svg;
  }
  async firstUpdated() {
    this.svg = await this.fetchIcon(this.icon);
  }
  render() {
    return html`${this.svg}`;
  }
}
Icon.styles = styles;
__decorateClass([property()], Icon.prototype, "icon", 2);
__decorateClass([property({
  type: Number,
  converter(value) {
    const allowedSizes = ["16", "24", "32", "64"];
    const getClosest = (counts, goal) => {
      return counts.reduce((prev, curr) => Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
    };
    if (!allowedSizes.includes(value)) {
      return getClosest(allowedSizes, value);
    }
    return value;
  }
})], Icon.prototype, "size", 2);
__decorateClass([property({
  type: Boolean
})], Icon.prototype, "filled", 2);
__decorateClass([property({
  type: Boolean
})], Icon.prototype, "outlined", 2);
__decorateClass([property({
  attribute: false
})], Icon.prototype, "svg", 2);
try {
  customElements.define("adc-icon", Icon);
} catch (error) {}
